export default {
  en: {
    courier: {
      awaitingCourierConfirmation: 'Confirm the order',
      awaitingRestaurant: 'Pick up the order',
      readyForPickup: 'Order is ready — pick it up',
      deliverToClient: 'Deliver to the customer',
      completed: 'Completed',
      cancelled: 'Cancelled',
      rejected: 'Declined',
      inProgress: 'In progress',
      delivering: 'Delivering',
    },
    restaurant: {
      awaitingPayment: 'Waiting for payment',
      awaitingRestaurantConfirmation: 'Waiting for restaurant confirmation',
      preparing: 'Order is being prepared',
      readyForPickup: 'Ready for pickup',
      completed: 'Completed',
      cancelled: 'Cancelled',
      listPaymentPending: 'Awaiting payment',
      listNew: 'Created',
      listPreparing: 'In progress',
      listHandToCourier: 'In progress',
      listAwaitingCourier: 'In progress',
      listWithCourier: 'In progress',
      listDelivering: 'In progress',
    },
    unknown: 'Unknown status',
  },
  ru: {
    courier: {
      awaitingCourierConfirmation: 'Подтвердите заказ',
      awaitingRestaurant: 'Заберите заказ',
      readyForPickup: 'Заказ готов — заберите',
      deliverToClient: 'Доставьте клиенту',
      completed: 'Выполнен',
      cancelled: 'Отменён',
      rejected: 'Отклонён',
      inProgress: 'В процессе',
      delivering: 'В доставке',
    },
    restaurant: {
      awaitingPayment: 'Ожидаем оплату',
      awaitingRestaurantConfirmation: 'Ожидаем подтверждение от ресторана',
      preparing: 'Заказ готовится',
      readyForPickup: 'Готов к выдаче',
      completed: 'Выполнен',
      cancelled: 'Отменён',
      listPaymentPending: 'Ожидает оплаты',
      listNew: 'Создан',
      listPreparing: 'В процессе',
      listHandToCourier: 'В процессе',
      listAwaitingCourier: 'В процессе',
      listWithCourier: 'В процессе',
      listDelivering: 'В процессе',
    },
    unknown: 'Неизвестный статус',
  },
}
